import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from '@core/constants/app';
import { ApplicationProgressResponse } from '@core/interfaces/api-responses/application-progress-response';
import { ApplicationProgressSharedService } from '@core/data/application-progress-shared.service';
import * as moment from 'moment';
import { FeatureFlagsService } from '@core/services/feature-flags.service';
import { ENABLE_MEDICARE_CARD_ASSET_2025 } from '@core/constants/feature-flags';
import {ApplicationConfigService} from '@core/data/application-config.service';

@Component({
  selector: 'app-intro',
  templateUrl: './intro.component.html',
  styleUrls: ['./intro.component.scss'],
})
export class IntroComponent {

  readonly requirements = ['whoCanUse', 'whenCanBeUsed', 'whatDoINeed', 'reminders', 'help', 'homeless'];
  readonly translationPrefix = 'pages.intro';
  readonly applicationYear: number;
  readonly materialId: string;
  resolvedApplication: ApplicationProgressResponse = null;
  resolvedEffectiveDate = null;
  revision = null;

  constructor(private router: Router,
              private applicationProgressSharedService: ApplicationProgressSharedService,
              private readonly featureFlags: FeatureFlagsService,
              private applicationConfigService: ApplicationConfigService) {
    const stateParam = this.router.getCurrentNavigation()?.extras.state;
    this.resolvedEffectiveDate = stateParam.requestedEffectiveDate;
    this.applicationYear = moment(this.resolvedEffectiveDate, 'YYYY-MM-DD').year();
    this.materialId = AppConstants.APPLICATION_MATERIAL_IDS[moment(stateParam.requestedEffectiveDate, 'YYYY-MM-DD').year()];
    this.applicationProgressSharedService.getData()
      .subscribe(response => {
          this.resolvedApplication = response;
      });
    this.applicationConfigService.getConfig()
      .subscribe(response => {
      this.revision = response.revision;
    });
  }

  get shouldShowMedicareCard(): boolean {
    return this.featureFlags.isFeatureEnabled(ENABLE_MEDICARE_CARD_ASSET_2025);
  }

  navigateDashboard(): void {
    this.router.navigate([AppConstants.DASHBOARD_PAGE]);
  }


  startApplication() {
    if (!this.resolvedApplication?.id){

      this.router.navigateByUrl(AppConstants.ELIGIBILITY_PAGE, { state: {
          requestedEffectiveDate: this.resolvedEffectiveDate, revision: this.revision } });
      return;
    }
    const step = this.resolvedApplication.lastStep;
    this.router.navigate(
      [AppConstants.getApiValueToStepsMapping()[step] + `/${this.resolvedApplication.id}`]);
    return;
  }

}
